/******************************************************************
 * Archivo : client/src/queries/fetchIsUserActive.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query IsUserActiveQuery {
    user {
      active
      mustChangePassword
      roles {
        id
        code
        label
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchIsUserActive.js